export default __webpack_public_path__ + "static/media/may-2019-international.8e7f3945.csv";